import { useEffect } from "react";
import { useAppAlert } from "./components/app-alert/use-app-alert";
import { useAxiosInterceptors } from "./hooks/use-axios-interceptors";
import Routing from "./routes/routes";
import { getReferenceLenderThunk, referenceDataThunk } from "./store/reference-data/reference-data-thunk-actions";
import { setLenderReferenceData, setReferenceData } from "./store/reference-data/reference-data-slice";
import { useAppDispatch } from "./store/store";
import { getDataFromLocalStorage } from "./utils/views-utils";
import { setLoginSuccess } from "./store/auth/auth-slice";
import {
  LOCALSTORAGEAUTHUSERINFO,
  LOCALSTORAGELENDERREFERENCEDATA,
  LOCALSTORAGEREFERENCEDATA,
} from "./constants/local-storage-constant";
import { myPersonalDetailsThunk } from "./store/personal-details/personal-details-thunk-actions";

const isAuth = getDataFromLocalStorage(LOCALSTORAGEAUTHUSERINFO);

const data = {
  token: isAuth?.token,
  user: isAuth?.user,
  role: isAuth?.role,
  refreshToken: isAuth?.refreshToken || "",
  success: isAuth?.success || "",
};

const referenceData = getDataFromLocalStorage(LOCALSTORAGEREFERENCEDATA);
const lenderReferenceData = getDataFromLocalStorage(LOCALSTORAGELENDERREFERENCEDATA);

function App() {
  const dispatch = useAppDispatch();
  const axiosInstance = useAxiosInterceptors();
  const { openAlert } = useAppAlert();

  useEffect(() => {
    if (!!isAuth?.token) {
      dispatch(setLoginSuccess(data as any));
    }
  }, []);

  useEffect(() => {
    if (!!isAuth?.token) {
      dispatch(myPersonalDetailsThunk({ axiosInstance, openAlert }));
    }
  }, []);

  useEffect(() => {
    if (!!referenceData) {
      dispatch(setReferenceData(referenceData));
      return;
    }
    dispatch(referenceDataThunk({ axiosInstance, openAlert }));
  }, []);

  useEffect(() => {
    if (!!isAuth?.token) {
      if (!!lenderReferenceData) {
        dispatch(setLenderReferenceData(lenderReferenceData));
      } else {
        dispatch(getReferenceLenderThunk({ axiosInstance }));
      }
    }
  }, []);

  return <Routing />;
}

export default App;
